export default __webpack_public_path__ + "static/media/CreatePasswordIcon.f39051b9.svg";